import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepGovernanceFormContainer from '../../../../containers/projects/ChangeStrategyFormContainers/StepGovernanceFormContainer.jsx';

const NewChangeStrategyStepGovernance = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>New Change Strategy | ChangeSync</title>
    </Helmet>
    <StepGovernanceFormContainer projectId={projectId} slug={slug} />
  </>
);

NewChangeStrategyStepGovernance.getInitialProps = ({ query }) => ({
  slug: query.slug,
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(NewChangeStrategyStepGovernance));
